import React, { useState, useEffect } from 'react'
import { IoIosArrowUp } from "react-icons/io"
import './TopViewIcon.css'

const TopViewIcon = () => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setShow(window.scrollY > 200)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <div
      className={`Digi-Health-top-view-icon-section-box${show ? ' Digi-Health-top-view-icon-section-show' : ''}`}
      onClick={scrollToTop}
      aria-label="Scroll to top"
      tabIndex={0}
      role="button"
    >
      <IoIosArrowUp className="Digi-Health-top-view-icon-section-arrow" />
    </div>
  )
}

export default TopViewIcon
